import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, useTheme, Grid, Select, MenuItem, CircularProgress, Autocomplete } from "@mui/material";
import SubHeader from "../../../../../components/SubHeader";
import PensionList from "./PensionList";
import styles from "./style";
import Modal from "../../../../../components/Modal";
import { CustomizedRadio } from "../../../../../components/CustomRadio";

const PensionPage = ({ employeeData, handleEmployee, data, pensionType, open, setOpen, handleAdd, total, page, setPage, handleDelete, handleFilter, loading }) => {
  const theme = useTheme();
  const radioPensionLabel = [{ label: "Pension - paid by company to fund", value: "Employer" }, { label: "Pension - paid directly by employee", value: "Employee" }];
  const radioAllowanceLabel = [{ label: "Amount", value: "Amount" }, { label: "Percentage", value: "Percentage" }];

  const [from, setFrom] = useState("");
  const [pensionPaid, setPensionPaid] = useState("");
  const [type, setType] = useState("");
  const [employeeAmount, setEmployeeAmount] = useState("");
  const [employerAmount, setEmployerAmount] = useState("");
  const [employeeRate, setEmployeeRate] = useState("");
  const [employerRate, setEmployerRate] = useState("");
  const [employeeSalary, setEmployeeSalary] = useState("");
  const [employerSalary, setEmployerSalary] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  // const [optionValue, setOptionValue] = useState("");
  const isEmployeeContributionOnly = pensionPaid === "Employee";

  const resetForm = () => {
    setPensionPaid("");
    setType("");
    setEmployeeAmount("");
    setEmployerAmount("");
    setEmployeeRate("");
    setEmployerRate("");
    setEmployeeSalary("");
    setEmployerSalary("");
    setEmployeeId("");
  };


  const handleData = () => {
    handleAdd(employeeId, pensionPaid, type, employeeAmount, employeeRate, employeeSalary, employerAmount, employerRate, employerSalary);
    setOpen(false);
  };

  const [item, setItem] = useState([]);
  const [change, setChange] = useState(false);
  console.log(change)

  useEffect(() => {
    if (from === "edit" && item) {
      setPensionPaid(item?.contributions?.[0]?.payment || "");
      setType(item?.contributions?.[0]?.type || "");
      setEmployeeAmount(item?.contributions?.[0]?.employeeCont?.type || "");
      setEmployerAmount(item?.contributions?.[0]?.employerCont?.type || "");
      setEmployeeRate(item?.contributions?.[0]?.employeeCont?.rateValue || "");
      setEmployerRate(item?.contributions?.[0]?.employerCont?.rateValue || "");
      setEmployeeSalary(item?.contributions?.[0]?.employeeCont?.payType || "");
      setEmployerSalary(item?.contributions?.[0]?.employeeCont?.payType || "");
      setEmployeeId(item?.employeeDetails?._id || "");
      setChange(false);
    } else if (from === "create") {
      resetForm();
    }
  }, [item, from]);


  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={styles.heading}>Pension</Typography>
        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          <Button variant="contained" color="success" sx={styles.checkoutBtn} onClick={() => {
            setOpen(true); setFrom("create"); resetForm();
          }}> + Add Pension </Button>
        </Box>
      </Box>

      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader title="Pension List"
          search={true}
          sortBy={true}
          onchange={(e) => handleFilter(e)}
          filter={handleFilter}
          isShowFilter={false}
          handleSort={(e) => handleFilter("", e)} />

        <PensionList page={page} total={total} setFrom={setFrom} setPage={setPage} data={data} handleDelete={handleDelete} setOpen={setOpen} setItem={setItem} />
      </Box>

      <Modal open={open} setOpen={setOpen} disabled={!pensionPaid || !type || !employeeAmount || !employeeRate || !employeeSalary} btnText={from === "edit" ? "Save Changes" : "Add New"} handleCheck={() => handleData()} title={from === "edit" ? "Edit Pension" : "Create Pension"}
        handleRequest={handleData}>
        <Grid container sx={styles.mainContainer}>
          <Grid item xs={12} lg={12} sx={styles.gridbox}>
            <>
              <Box sx={styles.inputSection}>
                <Box sx={{ display: "flex", mb: 1 }}>
                  <CustomizedRadio handleChange={(value) => setPensionPaid(value)} defaultChecked={pensionPaid} value={pensionPaid} radioLabel={radioPensionLabel} />
                </Box>
              </Box>

              <Grid container sx={styles.inputGrid}>
                <Grid item xs={12} lg={5.9} >
                  <Typography sx={styles.inputText}>Pension Type</Typography>
                  <Select
                    value={type}

                    onChange={(e) => setType(e.target.value)}
                    sx={styles.modalInput}
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                        Select
                    </MenuItem>
                    {pensionType?.map((item, index) => (
                      <MenuItem sx={styles.dropDownMenu} key={index} value={item?.name}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {from === "edit" ?

                  <Grid item xs={12} lg={5.9} >
                    <Typography sx={styles.inputText}>Employee Email</Typography>
                    <TextField
                      value={item?.employeeDetails?.personalInfo?.email}
                      onChange={(e) => { setEmployeeId(e.target.value); setChange(true); }}
                      rows={2}
                      sx={{ ...styles.modalInput, ...styles.inputSpace }}
                    />
                  </Grid>
                  :
                  <Grid item xs={12} lg={5.9} >
                    <Autocomplete
                      id="autocomplete"
                      options={employeeData || []}
                      getOptionLabel={(option) => option?.personalInfo?.email}
                      onInputChange={(event, newInputValue) => {
                        handleEmployee(newInputValue);
                      }}
                      onChange={(event, newValue) => {
                        setEmployeeId(newValue?._id);
                      }}
                      renderInput={(params) => (
                        <>
                          <Typography sx={styles.inputText}>Employee Email</Typography>
                          <TextField
                            {...params}
                            sx={{ ...styles.modalInput, ...styles.inputSpace }}
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }} />
                        </>
                      )}
                    />
                  </Grid>
                }
              </Grid>

              <Grid container sx={styles.mainContainerPension}>
                <Grid item xs={12} lg={12}>
                  <Box sx={styles.inputSection}>
                    <Typography sx={styles.inputText}>
                      Employee Pension Contribution
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                      <CustomizedRadio handleChange={(value) => setEmployeeAmount(value)} defaultChecked={employeeAmount} value={employeeAmount} radioLabel={radioAllowanceLabel} />
                    </Box>
                  </Box>

                  <Grid container sx={styles.inputGrid}>
                    <Grid item xs={12} lg={5.9}>
                      <Select
                        value={employeeSalary}
                        onChange={(e) => setEmployeeSalary(e.target.value)}
                        name="employeeSalary"
                        sx={styles.modalInput}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Gross">
                          Gross
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Salary">
                          Salary
                        </MenuItem>
                      </Select>
                    </Grid>

                    <Grid item xs={12} lg={5.9}>
                      <TextField
                        value={employeeRate}
                        name="rateValue"
                        onChange={(e) => setEmployeeRate(e.target.value)}
                        placeholder="0.00"
                        sx={styles.modalInput}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {!isEmployeeContributionOnly && (
                <Grid container sx={styles.mainContainerPension}>
                  <Grid item xs={12} lg={12}>
                    <Box sx={styles.inputSection}>
                      <Typography sx={styles.inputText}>
                        Employer Pension Contribution
                      </Typography>
                      <Box sx={{ mt: 1 }}>
                        <CustomizedRadio
                          handleChange={(value) => setEmployerAmount(value)}
                          defaultChecked={employerAmount}
                          value={employerAmount}
                          radioLabel={radioAllowanceLabel}
                        />
                      </Box>
                    </Box>

                    <Grid container sx={styles.inputGrid}>
                      <Grid item xs={12} lg={5.9}>
                        <Select
                          value={employerSalary}
                          onChange={(e) => setEmployerSalary(e.target.value)}
                          name="employerSalary"
                          sx={styles.modalInput}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            Select
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Gross">
                            Gross
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Salary">
                            Salary
                          </MenuItem>
                        </Select>
                      </Grid>

                      <Grid item xs={12} lg={5.9}>
                        <TextField
                          name="rateValue"
                          value={employerRate}
                          onChange={(e) => setEmployerRate(e.target.value)}
                          placeholder="0.00"
                          sx={styles.modalInput}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};


export default PensionPage;
